/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IsSubmitting/view.blocks to change it.
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function IsSubmitting({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/Contracts/Content/ApplyAction/Content/Loading/IsSubmitting"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="IsSubmitting.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
/>
</div>
{children}
</React.Fragment>)
}